export default {
  nav: {
    home: 'Início', profile: 'Perfil', assistant: 'Assistente',
    tickets: 'Pedidos', documents: 'Documentos', data: 'Dados', comms: 'Avisos',
    uniform: 'Fardamento', assets: 'Ativos', requests: 'Material', confirmations: 'Confirmações',
    training: 'Formações', absences: 'Ausências', approvals: 'Pedidos para aprovar',
  },
  abs: {
    title: 'Ausências', subtitle: 'Férias e outras ausências',
    noProfile: 'A sua conta ainda não está associada a uma ficha de colaborador. Contacte o RH.',
    loadError: 'Não foi possível carregar as suas ausências. Tente novamente.',
    balance: 'Saldo de férias', balanceYear: 'Saldo de férias {year}',
    availableOf: 'dias disponíveis de {total}',
    entitlement: 'Direito anual', used: 'Gozados', pendingDays: 'Pendentes',
    carry: 'Inclui {days} dias transitados.', carryExpires: 'Expiram em {date}.',
    newRequest: 'Novo pedido', kind: 'Tipo', from: 'De', to: 'Até',
    halfStart: 'Meio dia no primeiro dia', halfEnd: 'Meio dia no último dia',
    calculating: 'A calcular…', workingDays: '{n} dias úteis', balanceAfter: 'Saldo após o pedido: {n} dias',
    endBeforeStart: 'A data final não pode ser anterior à inicial.',
    certificate: 'Certificado (opcional)',
    certificatePrivacy: 'O certificado só é visto pelo RH. Quem aprova o pedido não o vê nem vê qualquer nota.',
    noteOptional: 'Nota (opcional)',
    sending: 'A enviar…', submit: 'Enviar pedido',
    previewFailed: 'Não foi possível calcular os dias.', submitFailed: 'Não foi possível enviar o pedido.',
    created: 'Pedido enviado.', createdCertFailed: 'Pedido enviado, mas o certificado não foi carregado. Contacte o RH para o entregar.',
    history: 'Os meus pedidos', empty: 'Ainda não fez nenhum pedido.',
    status: { pending: 'Pendente', approved: 'Aprovado', rejected: 'Rejeitado', cancelled: 'Cancelado' },
    hrAsked: 'O RH fez uma pergunta', hrAskedFull: 'O RH fez-lhe uma pergunta:',
    yourAnswer: 'A sua resposta', sendAnswer: 'Enviar resposta', answerSent: 'Resposta enviada.',
    trail: 'Histórico de decisões',
    event: {
      requested: 'Pedido', approved: 'Aprovado', rejected: 'Rejeitado', acknowledged: 'Tomado conhecimento',
      cancelled: 'Cancelado', comment: 'Comentário', hr_question: 'Pergunta do RH', answer: 'Resposta',
    },
    unknownActor: 'Sistema',
    decidedAs: { station_approver: 'Aprovador da estação', station_role: 'Gestão da estação', hr_fallback: 'RH (sem aprovador)', admin_own_leave: 'Administrador (ausência própria de gestor)' },
    cancel: 'Cancelar pedido', cancelConfirm: 'Cancelar este pedido?', keep: 'Manter', confirmCancel: 'Sim, cancelar',
    cancelled: 'Pedido cancelado.', actionFailed: 'Não foi possível concluir a ação.',
    daysShort: '{n} dias',
  },
  appr: {
    employer: { groundlink_iii: 'Groundlink', ryanair_dac: 'Ryanair DAC' },
    tabInbox: 'Pedidos', tabEntitlements: 'Dias de férias do ano',
    title: 'Pedidos para aprovar', subtitle: 'Pedidos de ausência da sua estação',
    loadError: 'Não foi possível carregar os pedidos. Tente novamente.',
    alreadyDecided: 'Este pedido já foi decidido.', actionFailed: 'Não foi possível concluir a ação.',
    approved: 'Pedido aprovado.', rejected: 'Pedido rejeitado.', acknowledged: 'Tomado conhecimento.',
    empty: 'Não há pedidos para aprovar.',
    age: 'Há {n} dias', overlap: '{n} colegas já ausentes nestas datas', noOverlap: 'Sem sobreposição na equipa',
    balanceAfter: 'saldo após: {n}',
    rejectReason: 'Motivo da rejeição (obrigatório)', back: 'Voltar', confirmReject: 'Rejeitar pedido',
    acknowledge: 'Tomar conhecimento', reject: 'Rejeitar', approve: 'Aprovar',
    cannotDecide: 'Não pode decidir este pedido.',
  },
  ent: {
    subtitle: 'Confirme os dias de férias anuais da sua base',
    loadError: 'Não foi possível carregar as sugestões. Tente novamente.',
    notApprover: 'Só os aprovadores de uma estação podem confirmar estes dias.',
    year: 'Ano', station: 'Estação', allStations: 'Todas',
    empty: 'Não há sugestões por confirmar.',
    select: 'Selecionar {name}', suggested: 'Sugestão: {n} dias', points: '{n} pontos',
    days: 'Dias a confirmar', reasonRequired: 'Motivo da alteração (obrigatório)',
    refusedSelf: 'Não pode confirmar os seus próprios dias. Peça a outro aprovador ou ao RH.',
    refusedStale: 'A sugestão mudou. Recarregue a lista.',
    refusedHr: 'Já confirmado pelo RH.',
    partial: '{ok} confirmados, {refused} recusados.', confirmedN: '{n} confirmados.',
    confirmFailed: 'Não foi possível confirmar.', reload: 'Recarregar',
    confirmSelected: 'Confirmar selecionados ({n})',
  },
  training: {
    title: 'Formações', subtitle: 'Os seus registos de conformidade',
    redirecting: 'A abrir as Formações…',
    error: 'Não foi possível abrir as Formações. Tente novamente em breve.',
    notLinked: 'A sua conta de Formações ainda não está associada. Volte mais tarde ou contacte o RH.',
    empty: 'Ainda não tem registos de formação.',
    openFull: 'Abrir plataforma de Formações completa',
    expires: 'Expira em',
    status: {
      VALID: 'Válido', WARNING_60: 'Expira em 60 dias', WARNING_30: 'Expira em 30 dias',
      WARNING_10: 'Expira em 10 dias', EXPIRED: 'Expirado',
    },
  },
  common: {
    logout: 'Sair', install: 'Instalar',
    portalName: 'Portal do Colaborador',
    footer: 'Groundlink III Handling, Lda. · Uso interno',
    loading: 'A carregar…',
    noRecord: 'Nenhum registo associado à sua conta.',
  },
  login: {
    welcome: 'Bem-vindo', lead: 'Aceda aos seus dados de RH.',
    email: 'Email', password: 'Palavra-passe',
    signIn: 'Entrar', signingIn: 'A entrar…', forgot: 'Esqueceu a palavra-passe?',
  },
  forgot: {
    title: 'Esqueceu a palavra-passe?',
    lead: 'Indique o seu email e enviamos-lhe uma ligação para a redefinir.',
    email: 'Email', send: 'Enviar ligação', sending: 'A enviar…', back: 'Voltar ao login',
    sentTitle: 'Verifique o seu email',
    sentLead: 'Se existir uma conta associada a {email}, enviámos uma ligação para redefinir a palavra-passe.',
  },
  setpw: {
    checking: 'A validar convite',
    invalidTitle: 'Ligação inválida ou expirada',
    invalidLead: 'Este convite já não é válido. Peça um novo à sua equipa de RH.',
    goLogin: 'Ir para o login',
    doneTitle: 'Conta ativada', doneLead: 'A redirecionar para o login…',
    title: 'Defina a sua palavra-passe',
    account: 'Conta:', chooseLead: 'Escolha uma palavra-passe para ativar a sua conta.',
    password: 'Palavra-passe', hint: 'Mínimo 10 caracteres, com letras e números.',
    confirm: 'Confirmar palavra-passe', activate: 'Ativar conta', activating: 'A ativar…',
    errShort: 'A palavra-passe deve ter pelo menos 10 caracteres.',
    errComplexity: 'A palavra-passe deve incluir letras e números.',
    errMatch: 'As palavras-passe não coincidem.',
    errGeneric: 'Não foi possível definir a palavra-passe.',
  },
  home: {
    morning: 'Bom dia', afternoon: 'Boa tarde', evening: 'Boa noite', fallbackName: 'Colaborador',
    profileTitle: 'O meu perfil', profileDesc: 'Dados pessoais e contrato',
    docsTitle: 'Os meus documentos', docsDesc: 'Recibos, contratos, certificados',
    gdprTitle: 'Privacidade (RGPD)', gdprDesc: 'Pedidos sobre os seus dados',
  },
  documents: {
    title: 'Os meus documentos', subtitle: 'Recibos, contratos e certificados',
    empty: 'Ainda não tem documentos disponíveis.', download: 'Descarregar',
    types: { payslip: 'Recibo', contract: 'Contrato', certificate: 'Certificado', circular: 'Circular', medical_certificate: 'Atestado médico', absence_justification: 'Justificação de ausência' },
  },
  privacy: {
    title: 'Privacidade e dados (RGPD)', subtitle: 'Os seus direitos sobre os dados pessoais',
    banner: 'A Groundlink III Handling trata os seus dados de acordo com o RGPD. Para colaboradores da Ryanair DAC, alguns pedidos poderão ser encaminhados para a Ryanair enquanto responsável pelo tratamento.',
    soon: 'Submissão de pedidos diretamente no portal — brevemente.',
    soonNote: 'Por agora, contacte o departamento de RH.',
    rights: [
      ['Acesso', 'Consultar os dados que a Groundlink III mantém sobre si.'],
      ['Retificação', 'Pedir a correção de dados incorretos ou desatualizados.'],
      ['Apagamento', 'Solicitar a eliminação dos seus dados, dentro dos limites legais de retenção.'],
      ['Portabilidade', 'Receber uma cópia dos seus dados num formato legível.'],
    ],
  },
  profile: {
    title: 'O meu perfil', subtitle: 'Os seus dados registados em RH',
    fields: {
      name: 'Nome', employeeId: 'Nº mecanográfico', email: 'Email', phone: 'Telefone',
      station: 'Estação', department: 'Departamento', position: 'Função',
      category: 'Categoria profissional', status: 'Estado', startDate: 'Data de admissão',
    },
    editable: {
      phone: 'Telefone', phone_secondary: 'Telefone (alternativo)', phone_home: 'Telefone (casa)',
      address: 'Morada', city: 'Localidade', postal_code: 'Código postal', marital_status: 'Estado civil',
      emergency_name: 'Contacto de emergência — nome',
      emergency_relationship: 'Contacto de emergência — parentesco',
      emergency_phone: 'Contacto de emergência — telefone',
    },
    requestTitle: 'Pedir correção de dados',
    requestLead: 'Escolha o campo, indique o valor correto e envie. O RH revê o pedido antes de aplicar.',
    fieldLabel: 'Campo', currentLabel: 'Valor atual', newLabel: 'Novo valor',
    newPlaceholder: 'Introduza o valor correto', submit: 'Enviar pedido', submitting: 'A enviar…',
    sent: 'Pedido enviado. Será revisto pelo RH.',
    errValue: 'Indique o novo valor.', errSend: 'Não foi possível enviar o pedido.',
    myRequests: 'Os meus pedidos', hrNote: 'Nota RH:',
    loadError: 'Não foi possível carregar o seu perfil.',
    status: { pending: 'Pendente', approved: 'Aprovado', rejected: 'Rejeitado' },
  },
  tickets: {
    title: 'Pedidos ao RH', subtitle: 'As suas questões e o histórico de respostas',
    new: 'Novo pedido', newTitle: 'Novo pedido',
    empty: 'Ainda não tem pedidos. Abra um novo acima.',
    subject: 'Assunto', subjectPlaceholder: 'Assunto do pedido',
    message: 'Mensagem', messagePlaceholder: 'Descreva a sua questão',
    cancel: 'Cancelar', send: 'Enviar pedido', sending: 'A enviar…',
    errFill: 'Preencha o assunto e a mensagem.', errSend: 'Não foi possível enviar o pedido.',
    back: '← Voltar aos pedidos', replyPlaceholder: 'Escreva uma resposta…',
    me: 'Eu', hr: 'RH', loadError: 'Não foi possível carregar o pedido.',
    categories: { general: 'Geral', payroll: 'Vencimento', contract: 'Contrato', leave: 'Ausências', documents: 'Documentos', it: 'Informática' },
    status: { open: 'Em aberto', answered: 'Respondido', closed: 'Fechado' },
  },
  comms: {
    title: 'Avisos', subtitle: 'Comunicações internas de RH',
    empty: 'Sem comunicações de momento.',
    allEmployers: 'Todas as empresas', allStations: 'Todas as estações', unread: 'Não lida',
  },
  faq: {
    title: 'Perguntas frequentes', subtitle: 'Respostas às questões mais comuns de RH',
    searchPlaceholder: 'Pesquisar…', search: 'Pesquisar',
    empty: 'Sem resultados. Experimente outros termos ou pergunte ao Assistente.',
  },
  assistant: {
    title: 'Assistente', subtitle: 'Perguntas sobre os seus dados de RH',
    lead: 'Pergunte sobre o seu perfil, documentos, datas de contrato ou pedidos. Só acedo aos seus dados.',
    faqLink: 'Ver perguntas frequentes',
    disclaimer: 'O assistente pode cometer erros. Para alterar dados, use “Pedir correção” no seu perfil.',
    escalate: 'Enviar ao RH', placeholder: 'Escreva a sua pergunta…',
    errUnavailable: 'O assistente não está disponível de momento.',
    suggestions: [
      'Quando expira o meu documento de identificação?',
      'Que documentos tenho disponíveis?',
      'Qual é a data de fim do meu contrato?',
      'Qual o estado dos meus pedidos de correção?',
    ],
  },
  logisticsUniform: {
    title: 'O Meu Fardamento', subtitle: 'Peças atribuídas e datas de renovação',
    empty: 'Ainda não tem fardamento atribuído.',
    confirmReceipt: 'Confirmar receção', confirmed: 'Confirmado', confirming: 'A confirmar…',
    requestAdjustment: 'Pedir extensão/encurtamento', deltaMonths: 'Meses (+/-)', reason: 'Motivo',
    reasonPlaceholder: 'Porque precisa de mais/menos tempo?', send: 'Enviar pedido', sending: 'A enviar…',
    cancel: 'Cancelar', errFill: 'Preencha os meses e o motivo.', errSend: 'Erro ao enviar pedido.',
    adjustmentStatus: { pending: 'Pedido pendente', approved: 'Pedido aprovado', rejected: 'Pedido rejeitado' },
    status: { active: 'Ativo', returned: 'Devolvido', lost: 'Perdido', written_off: 'Abatido' },
    errLoad: 'Erro ao carregar o fardamento. Tenta novamente.', retry: 'Tentar novamente',
  },
  logisticsAssets: {
    title: 'Os Meus Ativos', subtitle: 'Equipamento à sua responsabilidade',
    empty: 'Ainda não tem ativos atribuídos.',
    category: { HEADSET: 'Headset', RADIO: 'Rádio', PHONE: 'Telemóvel', IT_EQUIPMENT: 'Equipamento informático', OFFICE: 'Material de escritório' },
    errLoad: 'Erro ao carregar os ativos. Tenta novamente.', retry: 'Tentar novamente',
  },
  logisticsRequests: {
    title: 'Os Meus Pedidos de Material', subtitle: 'Pedidos internos e o seu estado',
    empty: 'Ainda não tem pedidos de material.',
    errLoad: 'Erro ao carregar os pedidos. Tenta novamente.', retry: 'Tentar novamente',
    new: 'Novo pedido', newTitle: 'Novo pedido de material',
    urgency: 'Urgência', urgencyLow: 'Baixa', urgencyNormal: 'Normal', urgencyHigh: 'Alta',
    justification: 'Justificação', justificationPlaceholder: 'Porque precisa deste material?',
    product: 'Produto', quantity: 'Qtd.', addLine: '+ Adicionar linha',
    selectProduct: 'Selecionar…', cancel: 'Cancelar', send: 'Enviar pedido', sending: 'A enviar…',
    errFill: 'Escolha pelo menos um produto e quantidade.', errSend: 'Erro ao enviar pedido.',
    status: {
      open: 'Aberto', fulfilled_by_stock: 'Satisfeito', converted_to_po: 'Em encomenda',
      rejected: 'Rejeitado', closed: 'Fechado',
    },
    detail: {
      title: 'Pedido', back: 'Os meus pedidos',
      attachments: 'Anexos', noAttachments: 'Sem anexos.',
      upload: 'Enviar', errUpload: 'Erro ao enviar anexo.',
      errLoad: 'Erro ao carregar o pedido.', retry: 'Tentar novamente',
    },
  },
  logisticsConfirmations: {
    title: 'Confirmações de Receção', subtitle: 'Encomendas à espera de confirmação na sua base',
    empty: 'Sem confirmações pendentes.',
    accept: 'Confirmar receção', reject: 'Rejeitar confirmação',
    rejectPrompt: 'Motivo da rejeição (opcional):',
    confirmed: 'Confirmada', rejected: 'Rejeitada — fica registada, alguém resolve manualmente',
  },
};
